/**
 * OPLYX flow primitives — thin lines, live nodes, directional cues.
 * Use sparingly; never decorative.
 */

export function LiveNode({ size = 6, pulse = true, className = "" }) {
  return (
    <span
      className={`inline-block rounded-full bg-[#00FF88] ${pulse ? "oplyx-pulse" : ""} ${className}`}
      style={{ width: size, height: size, boxShadow: pulse ? "0 0 0 0 rgba(0,255,136,0.5)" : undefined }}
      aria-hidden="true"
    />
  );
}

/**
 * Horizontal connecting line. Optional `live` toggles the brand-green tone.
 * Used between sections, KPIs, pipeline stages.
 */
export function ConnectingLine({ live = false, vertical = false, className = "" }) {
  const base = live
    ? "bg-[#00FF88]/40"
    : "bg-current opacity-10";
  return vertical
    ? <span className={`block w-px ${base} ${className}`} />
    : <span className={`block h-px w-full ${base} ${className}`} />;
}

/**
 * SVG flow path — for module-to-module connections in dashboards.
 */
export function FlowPath({ d, live = false, className = "" }) {
  return (
    <svg className={`pointer-events-none ${className}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d={d}
        stroke={live ? "#00FF88" : "currentColor"}
        strokeWidth={1}
        strokeOpacity={live ? 0.55 : 0.1}
        strokeLinecap="round"
      />
    </svg>
  );
}
